import store from 'Store'
import Nprogress from 'nprogress'
// helpers
import { networkErrorPage } from '../helpers'
import { Notification } from 'Utils/Classes/Notification'

// Preparing notifiaction
const notification = new Notification()
notification.message = 'Ha habido un error con el servidor'

export const loadClients = async (next) => {
  Nprogress.start()
  try {
    const clients = await store.dispatch('clients/load')

    if (!clients.data) throw clients
    Nprogress.done()
    return next()
  } catch (error) {
    Nprogress.done()
    // assuming network error
    if (!error.response) {
      return next(networkErrorPage)
    }
    next({ name: 'dashboard' })
    notification.dispatch()
  }
}
